import type { SVGProps } from 'react';

const SvgCredit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 2.995c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
    <path
      fill="currentcolor"
      d="M12 9.995c.53 0 1.04.21 1.41.59a.996.996 0 1 0 1.41-1.41c-.51-.51-1.14-.85-1.83-1.03v-1.14c0-.55-.45-1-1-1s-1 .45-1 1v1.14c-1.72.45-3 2-3 3.86s1.28 3.41 3 3.86v1.14c0 .55.45 1 1 1s1-.45 1-1v-1.14c.68-.18 1.32-.52 1.83-1.03a.996.996 0 1 0-1.41-1.41c-.39.39-.88.59-1.41.59-1.1 0-2-.9-2-2s.9-2 2-2z"
    />
  </svg>
);
export default SvgCredit;
